<script>
import Header from '@/components/Header';
import CodeFooter from '@/views/Code/Footer';
import UserFooter from '@/views/User/Footer';
import AntagonistFooter from '@/views/Antagonist/Footer';

import config from '@/config/config';

export default {
  name: 'App',
  components: {
    Header,
    CodeFooter,
    UserFooter,
    AntagonistFooter,
  },
  computed: {
    app() {
      return config.app;
    },
    footer() {
      if (config.app === 'user') {
        return UserFooter;
      } else if (config.app === 'antagonist') {
        return AntagonistFooter;
      }
      return CodeFooter;
    },
  },
  created() {
    if (config.app === 'antagonist') {
      document.title = 'Antagonist Academy';
    }
  },
};
</script>
<style lang="scss">
  @import './styles/app';
</style>
<template>
  <div id="app" class="d-flex min-vh-100 flex-column justify-content-between">
    <Header />
    <section id="content" :class="{'app-user': app === 'user'}">
      <router-view/>
    </section>
    <Component :is="footer" />
  </div>
</template>
